<template>
  <div class="modal-docs" >

    <div class="row">
      <div class="col-md-2" style="display:none;">
        <p>{{ trans.get('b2b.orders.document-no') }}</p>
        <p>{{idDocumento}}</p>
      </div>
      <div class="col-md-2">
        <p>{{ trans.get('b2b.orders.document-no') }}</p>
        <p>{{numDocumento}}</p>
      </div>
      <div class="col-md-2">
        <p>{{ trans.get('b2b.orders.date') }}</p>
        <p>{{parseDate}}</p>
      </div>
      <div class="col-md-2">
        <p>{{ trans.get('b2b.orders.status') }}</p>
        <p>{{stato.testo}}</p>
      </div>
      <div class="col-md-2">
        <p>{{ trans.get('b2b.orders.price') }}</p>
        <p>{{importo.toLocaleString('it-IT', {minimumFractionDigits: 3})}} €</p>
      </div>
      <!-- <div class="col-md-3 annulla">
        <a v-if="stato !== 'Completato'" class="link-ret red">Annulla ordine</a>
      </div> -->
      <div class="col-md-1 close">
        <img @click="close" :src="url('/media/icons/svg/close.svg')" alt="close">
      </div>
    </div>

    <div class="row doc" v-for="(riga,key) in righe">

      <docCard
          class="docCard"
      :codart="riga.codArt"
      :descrizione="riga.desEstesa"
      :quantita="riga.quantita"
      :totale="riga.importo"
      :unitamisura="riga.unitaMisura"
      :prezzo="riga.prezzo"
          :chiave = "key"
          @loaded="loadedComponent"

      />

    </div>
  </div>
</template>

<script>
import docCard from './doc-card'
export default {
  name: "modal-documenti",
  components: {
    docCard
  },
  props: [
    'idDocumento',
    'numDocumento',
    'data',
    'stato',
    'importo'
  ],
  data: function () {
    return {
      righe: null,
      isLoaded: false,
      openLoading: false
    }
  },
  computed: {
    parseDate: function () {
      let data = new Date(this.data);
      let anno = data.getFullYear();
      let mese = data.getMonth();
      let giorno = data.getDay();
      return `${giorno}-${mese}-${anno}`;
    },
  },
  mounted() {
    this.openLoading = true
    this.getDocs()
  },
  methods: {
    loadedComponent: function (value) {
      if (this.righe.length - 1 === value){
        this.openLoading = false
      }
    },
    getDocs: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/righedoc',
        params: {
          idDocumento: this.idDocumento
        }
      })
      .then(res =>{
        //console.log(res.data)
        if (res.data){
          this.righe = res.data
        }

      })
      .catch (err =>{
        console.log(err.response)
      })
    },
    close: function () {
      this.$emit('closed', this.idDocumento)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-docs {
    width: 100%;
    height: calc(100vh - 80px);
  overflow-y: auto;
  padding-top: 50px;
  position: relative;
  background-color: white;
  .annulla {
    display: flex;
    align-items: center;
  }
  .row.doc{
    margin-top: 20px;

  }
  .docCard {
    margin: 5px 0;
  }
 .close{
   display: flex;
   justify-content: flex-end;
   padding-top: 10px;
 }
  img {
    cursor: pointer;
    height: 11px;
    filter: brightness(0);
  }
  p {
    padding: 5px 0;
  }
  }

</style>
